// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"cW-z","sponsoredTooltipWrapper":"dW-z","sponsoredTooltip":"eW-z","newCard":"fW-z"};